import React, { useContext } from 'react';
import notecontext from '../context/notes/Notecontext';

export default function Noteitem(props) {
  const context = useContext(notecontext);
  const { deletenote } = context;
  const { editnote } = context;
  const { e , updatenote} = props;

  const handleDelete = () => {
    deletenote(e._id);
    alert('Note deleted!');
  };

  return (
    <div className='col-md-3 my-2'>
      <div className="card h-100 border-0 shadow-sm">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between align-items-start">
            {e.title}
            <div></div>
          </h5>
          <p className="card-text" style={{minHeight:'48px'}}>{e.description}</p>
          <div className="d-flex justify-content-end">
            <i className="fas fa-edit mx-2 text-primary" onClick={() => { updatenote(e); }} style={{ cursor: "pointer" }} title="Edit"></i>
            <i className="fas fa-trash-alt text-danger" onClick={handleDelete} style={{ cursor: "pointer" }} title="Delete"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
